import { render, staticRenderFns } from "./BookbindingCollectionInfo.vue?vue&type=template&id=077a2e2c&"
import script from "./BookbindingCollectionInfo.vue?vue&type=script&lang=ts&"
export * from "./BookbindingCollectionInfo.vue?vue&type=script&lang=ts&"
import style0 from "./BookbindingCollectionInfo.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCol } from 'vuetify/lib/components/VGrid';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VTooltip } from 'vuetify/lib/components/VTooltip';
installComponents(component, {VCol,VRow,VTooltip})
